export default __webpack_public_path__ + "static/media/guasasapo-sello-redondo-final.1cceeff8.png";